import React from "react";
import { useRecoilState } from "recoil";

import LSRgH2HeadLine from "../text/linSeedKr/Rg/lsRgH2HeadLine";
import LSBdH2HeadLine from "../text/linSeedKr/Bd/lsBdH2HeadLine";
import Radio from "../../atoms/input/radio";
import {
  onboardingState,
  onboardingUserTagState,
} from "../../../store/onboardingState";
import useDisplay from "../../../hooks/useDisplay";

function RadioForm({
  questionList,
  style,
  questionValue,
  questionKey,
  numbering,
  title,
  radioStyle,
}) {
  const { isMobile, isTablet, isDesktop } = useDisplay();

  const [onboardingStateAtom, setOnboardingStateAtom] =
    useRecoilState(onboardingState);

  const [onboardingUserTagStateAtom, setOnboardingUserTagStateAtom] =
    useRecoilState(onboardingUserTagState);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          ...style,
        }}
      >
        <LSBdH2HeadLine
          style={{
            color: "#5050FF",
            width: 30,
            marginRight: 8,
            fontSize: isMobile ? 14 : 18,
            lineHeight: isMobile ? "19.6px" : "25.2px",
          }}
        >
          {numbering}
        </LSBdH2HeadLine>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <LSRgH2HeadLine
            style={{
              color: "#101113",
              marginBottom: isMobile ? 10 : 24,
              fontSize: isMobile ? 14 : 18,
              lineHeight: isMobile ? "19.6px" : "25.2px",
            }}
          >
            {title}
          </LSRgH2HeadLine>

          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              width: "100%",
              gap: isMobile ? 16 : 10,
              ...radioStyle,
            }}
          >
            {questionList.map((item, index) => {
              return (
                <Radio
                  style={{
                    flex: 1,
                  }}
                  key={item.title}
                  id={`${questionKey}-${index}`}
                  name={questionKey}
                  checked={questionValue === item.title}
                  value={item.title}
                  valueText={item.title}
                  onChange={() => {
                    setOnboardingStateAtom({
                      ...onboardingStateAtom,
                      [questionKey]: item.title,
                    });

                    setOnboardingUserTagStateAtom({
                      ...onboardingUserTagStateAtom,
                      [questionKey]: item.value,
                    });
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default RadioForm;
